import axios from 'axios'
import auth from '../utils/auth' 
import cfg from '../utils/config'

const getClientes = async () => {
    const userInfo = auth.getUserInfo()
    
    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/cliente/'
    const config = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

    try {
        const response = await axios.get(requestURL, config)
        return response.data.results
    } catch (error) {
        console.error('Erro ao buscar clientes:', error)
        return []
    }
}
const getCliente = async (ClienteId) => {
    const userInfo = auth.getUserInfo()
    
    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/cliente/${ClienteId}/`
    const config = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

    try {
        const response = await axios.get(requestURL, config)
        return response.data
    } catch (error) {
        console.error('Erro ao buscar cliente:', error)
        return {}
    }
}

const getClientesModulo = async (identificacaoModulo) => {
    const userInfo = auth.getUserInfo()
    const idModulo = userInfo.menu.find((modulo) => modulo.item == identificacaoModulo)?.id ?? false

    if(!idModulo) return
    
    const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/acesso/modulo/${idModulo}/revenda/` + `?monitorado_restrito=${userInfo.monitorado_restrito}`
    const config = { headers: { Authorization: `Bearer ${auth.getToken()}` } }

    try {
        const response = await axios.get(requestURL, config)
        return response.data
    } catch (error) {
        console.error('Erro ao buscar clientes:', error)
        return []
    }
} 

const createOptionsClientes = (clientes) => {
    return clientes.map((item) => {
        const label = item?.nome_fantasia ?? item?.cliente__nome_fantasia
        const value = item?.id ?? item?.cliente__id

        return { label, value}
    })
}

const getOptionCliente = (clientes, clienteId) => {
    return clientes.find((item) => item.value == clienteId) || null
}

export { getClientes, getCliente, getClientesModulo, createOptionsClientes, getOptionCliente }